module.exports = __webpack_public_path__ + "static/media/AF.89180112.png";